import { useTranslation } from "react-i18next";
import { formatDateAndTime } from "../../../../utils";

const ChangeNoteLog = ({
  createdAt,
  value,
  updatedBy,
}: {
  createdAt: string;
  value?: string;
  updatedBy: string;
}) => {
  const { t } = useTranslation();

  // Parse the JSON string to an array
  let parsedValue = [];
  try {
    parsedValue = value ? JSON.parse(value) : [];
  } catch (error) {
    console.error("Failed to parse value:", value);
  }

  // Extract values from the array
  const oldNote = parsedValue.length > 0 ? parsedValue[0].split(": ")[1] : null;
  const newNote = parsedValue.length > 1 ? parsedValue[1].split(": ")[1] : null;
  const logType = parsedValue.length > 2 ? parsedValue[2].split(": ")[1] : null;
  if (logType == "internal") {
    return (
      <div className="card-auto p-24 my-10 row row-column gap-8">
        <div>{formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
        <div>
          {updatedBy} {t("changed")} <strong>{t("Internal Note")}</strong>
        </div>
        <br /> {t("from")}
        <div>
          <br /> {oldNote}
        </div>
        <div>
          <br /> {t("to")}
        </div>
        <div>
          <br /> {newNote} {/* New Value */}
        </div>
      </div>
    );
  } else {
    return (
      <div className="card-auto p-24 my-10 row row-column gap-8">
        <div>{formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
        <div>
          {updatedBy} {t("changed")} <strong>{t("External Note")}</strong>
        </div>
        <br /> {t("from")}
        <div>
          <br /> {oldNote}
        </div>
        <div>
          <br /> {t("to")}
        </div>
        <div>
          <br /> {newNote} {/* New Value */}
        </div>
      </div>
    );
  }
};

export default ChangeNoteLog;
